import request from '../api';

// 创建音频
export function createAudio(params: any): Promise<any> {
  return request.post('/app/make/tts', params);
}

// 获取音频生成进度
export function getAudioProgress(params: any): Promise<any> {
  return request.post('/app/make/getProgress', params);
}

// 获取情绪音色列表
export function getTimbreEmoPage(params: any): Promise<any> {
  return request.post('/app/timbreExtend/getAppTimbreEmoPage', params);
}

// 添加音色情绪
export function addTimbreEmo(timbreId: number): Promise<any> {
  return request.post(
    '/app/timbreExtend/addTimbreEmo',
    {},
    {
      params: { timbreId },
    }
  );
}

// 获取App音色拓展详情
export function getTimbreEmoDetail(id: string): Promise<any> {
  return request.post(`/app/timbreExtend/getAppTimbreEmo/${id}`);
}
